import { useState, useEffect } from 'react';

export default function Home() {
  const [activeTab, setActiveTab] = useState('overview');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Inject Schema.org JSON-LD
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": `${siteUrl}/#business`,
          "name": "Lotus Office",
          "url": siteUrl,
          "logo": "https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/2269d27feb85b3888c2fd412aad4574d.jfif",
          "image": "https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/7d5a4698d1abc4876590ff6223eeea8e.jfif",
          "description": "Lotus Office cung cấp dịch vụ văn phòng trọn gói tại Long Biên và Gia Lâm, Hà Nội. Văn phòng khép kín 15m2–130m2, đầy đủ nội thất, điều hòa, wifi, lễ tân chuyên nghiệp.",
          "telephone": "+84936685115",
          "email": "lotusoffice190@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "TT02-05 TSG Lotus, 190 Sài Đồng",
            "addressLocality": "Long Biên",
            "addressRegion": "Hà Nội",
            "addressCountry": "VN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 21.0583,
            "longitude": 105.8918
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
              "opens": "08:00",
              "closes": "18:00"
            }
          ],
          "sameAs": [
            "https://www.facebook.com/lotusoffice190sd",
            "https://www.tiktok.com/@lotusoffice190saidong"
          ],
          "priceRange": "7.000.000 VNĐ/tháng",
          "currenciesAccepted": "VND",
          "paymentAccepted": "Cash, Bank Transfer",
          "areaServed": {
            "@type": "City",
            "name": "Hà Nội"
          }
        },
        {
          "@type": "WebSite",
          "@id": `${siteUrl}/#website`,
          "url": siteUrl,
          "name": "Lotus Office",
          "description": "Văn phòng trọn gói Long Biên Hà Nội",
          "inLanguage": "vi-VN"
        },
        {
          "@type": "WebPage",
          "@id": `${siteUrl}/#webpage`,
          "url": siteUrl,
          "name": "Lotus Office - Văn Phòng Trọn Gói Long Biên Hà Nội",
          "isPartOf": { "@id": `${siteUrl}/#website` },
          "about": { "@id": `${siteUrl}/#business` },
          "inLanguage": "vi-VN"
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Lotus Office cho thuê văn phòng ở đâu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Lotus Office có 2 cơ sở: Lotus Office 1 tại TT02-05 TSG Lotus, 190 Sài Đồng, Long Biên, Hà Nội và Lotus Office 2 tại SB23-147 & SB23-367, Vinhomes Ocean Park Gia Lâm, Hà Nội."
              }
            },
            {
              "@type": "Question",
              "name": "Giá thuê văn phòng trọn gói tại Lotus Office là bao nhiêu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Lotus Office cung cấp 3 gói: Gói Cơ Bản từ 7.000.000 VNĐ/tháng (15m2), Gói Tiêu Chuẩn từ 9.000.000 VNĐ/tháng (25m2), Gói Cao Cấp từ 13.000.000 VNĐ/tháng (50m2 trở lên)."
              }
            },
            {
              "@type": "Question",
              "name": "Lotus Office có những dịch vụ gì?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Lotus Office cung cấp văn phòng khép kín, dịch vụ lễ tân, phòng họp, khu vực đỗ xe, thang máy, wifi miễn phí, điều hòa và dịch vụ vệ sinh."
              }
            },
            {
              "@type": "Question",
              "name": "Liên hệ Lotus Office như thế nào?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Bạn có thể liên hệ Lotus Office qua hotline 0936 685 115, email lotusoffice190@gmail.com hoặc nhắn tin qua Zalo/Facebook."
              }
            }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Bảng giá văn phòng trọn gói Lotus Office",
          "itemListElement": [
            {
              "@type": "Offer",
              "name": "Gói Cơ Bản",
              "description": "Văn phòng khép kín 15m2 dành cho 3-5 nhân viên, đầy đủ nội thất, điều hòa, wifi",
              "price": "7000000",
              "priceCurrency": "VND",
              "priceSpecification": {
                "@type": "UnitPriceSpecification",
                "price": "7000000",
                "priceCurrency": "VND",
                "unitText": "tháng"
              }
            },
            {
              "@type": "Offer",
              "name": "Gói Tiêu Chuẩn",
              "description": "Văn phòng khép kín 25m2 dành cho 5-7 nhân viên, có ban công, lễ tân, wifi",
              "price": "9000000",
              "priceCurrency": "VND",
              "priceSpecification": {
                "@type": "UnitPriceSpecification",
                "price": "9000000",
                "priceCurrency": "VND",
                "unitText": "tháng"
              }
            },
            {
              "@type": "Offer",
              "name": "Gói Cao Cấp",
              "description": "Văn phòng khép kín từ 50m2 trở lên dành cho trên 8 nhân viên, lễ tân chuyên nghiệp",
              "price": "13000000",
              "priceCurrency": "VND",
              "priceSpecification": {
                "@type": "UnitPriceSpecification",
                "price": "13000000",
                "priceCurrency": "VND",
                "unitText": "tháng"
              }
            }
          ]
        }
      ]
    };

    const existingScript = document.getElementById('schema-jsonld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'schema-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-jsonld');
      if (s) s.remove();
    };
  }, []);

  // Danh sách ảnh cho slideshow
  const heroImages = [
    'https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/7d5a4698d1abc4876590ff6223eeea8e.jfif',
    'https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/59dc4c86e68caa2bed784c5dd7f74d20.jfif',
    'https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/3c8f98c6f7a417181ca6bce62d8434c3.jfif',
    'https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/73e6f6ce573420aea7545b63dc8e9a2f.jfif',
    'https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/3c1dd89951fc1303df8a9f26d1aa75ac.jfif'
  ];

  // Auto-change image every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [heroImages.length]);

  const services = [
    {
      icon: 'ri-building-line',
      title: 'Văn phòng khép kín',
      description: 'Văn phòng khép kín với nhiều diện tích từ 15m2 - 130m2',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Vị trí kết nối',
      description:
        'Vị trí tại mặt đường chính, gần các tiện ích như chung cư, ngân hàng, TTTM...',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Dịch vụ lễ tân',
      description: 'Hỗ trợ tiếp khách và các dịch vụ văn phòng chuyên nghiệp',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Tiện ích chung',
      description: 'Tòa nhà có thang máy, khu vực lễ tân và sảnh tiếp khách',
    },
    {
      icon: 'ri-group-line',
      title: 'Phòng họp',
      description: 'Không gian họp chuyên nghiệp với trang thiết bị hiện đại',
    },
    {
      icon: 'ri-car-line',
      title: 'Khu vực đỗ xe',
      description: 'Khu vực đỗ xe rộng rãi, thuận tiện cho khách hàng',
    },
  ];

  const locations = [
    {
      name: 'Lotus Office 1',
      address: 'TT02-05 TSG Lotus, 190 Sài Đồng, Long Biên, Hà Nội',
      features: [
        'Gần các khu đô thị mới: Vinhomes Riverside, Vinhomes Symphony',
        'Tiếp cận nhanh các cung đường huyết mạch',
        'Gần Vincom Plaza, AEON Mall',
        'Gần các ngân hàng: BIDV, Agribank, Techcombank',
      ],
      image:
        'https://mcusercontent.com/2dd56814d19c9cf52b73d1e64/images/7ddef41d-8c2d-cb8c-0163-600d28929e95.jpg',
    },
    {
      name: 'Lotus Office 2',
      address: 'SB23-147 & SB23-367, Vinhomes Ocean Park Gia Lâm, Hà Nội',
      features: [
        '2 phút ra quốc lộ 5 kết nối sân bay Nội Bãi',
        '5 phút ra cao tốc Hà Nội - Hải Phòng',
        '10-15 phút tới 3 khu đô thị Vinhomes',
        '20 phút kết nối Hồ Gươm',
      ],
      image:
        'https://mcusercontent.com/2dd56814d19c9cf52b73d1e64/images/ddb8924b-d410-5d56-00ea-aae1542f5d88.jpg',
    },
  ];

  const pricingPlans = [
    {
      name: 'Gói Cơ Bản',
      subtitle: 'dành cho 3-5 nhân viên',
      price: '7,000,000',
      period: 'VNĐ/tháng',
      features: [
        'Văn phòng khép kín 15m2',
        'Đầy đủ nội thất cơ bản',
        'Điều hòa, wifi miễn phí',
        'Dịch vụ vệ sinh',
      ],
      popular: false,
    },
    {
      name: 'Gói Tiêu Chuẩn',
      subtitle: 'dành cho 5-7 nhân viên',
      price: '9,000,000',
      period: 'VNĐ/tháng',
      features: [
        'Văn phòng khép kín 25m2, có ban công thoáng',
        'Đầy đủ nội thất cơ bản',
        'Điều hòa, wifi miễn phí',
        'Dịch vụ lễ tân',
        'Dịch vụ vệ sinh',
      ],
      popular: true,
    },
    {
      name: 'Gói Cao Cấp',
      subtitle: 'dành cho trên 8 nhân viên',
      price: '13,000,000',
      period: 'VNĐ/tháng',
      features: [
        'Văn phòng khép kín từ 50m2 trở lên',
        'Đầy đủ nội thất cơ bản',
        'Điều hòa, wifi miễn phí',
        'Dịch vụ lễ tân chuyên nghiệp',
        'Dịch vụ vệ sinh',
      ],
      popular: false,
    },
  ];

  // Simple form submission handler with basic validation and error handling
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = {
      name: form.name.value.trim(),
      phone: form.phone.value.trim(),
      email: form.email.value.trim(),
      location: form.location.value,
      message: form.message.value.trim(),
    };

    // Basic client‑side validation
    if (!data.name || !data.phone) {
      alert('Vui lòng nhập họ và tên, số điện thoại.');
      return;
    }

    try {
      // Placeholder for real API call
      console.log('Submitting form data:', data);
      alert('Yêu cầu của bạn đã được gửi thành công!');
      form.reset();
    } catch (err) {
      console.error('Form submission error:', err);
      alert('Đã xảy ra lỗi, vui lòng thử lại sau.');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <img
                src="https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/2269d27feb85b3888c2fd412aad4574d.jfif"
                alt="Lotus Office Logo"
                className="h-8 sm:h-10 w-auto"
              />
              <h1
                className="text-lg sm:text-2xl font-bold text-amber-600 ml-2 sm:ml-3"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '700',
                  letterSpacing: '0.05em',
                }}
              >
                LOTUS OFFICE
              </h1>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#home" className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">
                Trang chủ
              </a>
              <a href="#services" className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">
                Dịch vụ
              </a>
              <a href="#locations" className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">
                Địa điểm
              </a>
              <a href="#pricing" className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">
                Bảng giá
              </a>
              <a href="#contact" className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">
                Liên hệ
              </a>
            </nav>
            <div className="flex items-center space-x-4">
              <a
                href="tel:0936685115"
                className="bg-gradient-to-r from-red-500 to-orange-5text-white px-3 sm:px-6 py-2 sm:py-3 rounded-lg hover:from-red-600 hover:to-orange-600 transition-all duration-300 cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105 animate-pulse text-sm sm:text-base"
                style={{
                  animation: 'shake 2s infinite, pulse 2s infinite',
                }}
              >
                <i className="ri-phone-line mr-1 sm:mr-2 text-sm sm:text-lg"></i>
                <span className="font-semibold hidden sm:inline">0936 685 115</span>
                <span className="font-semibold sm:hidden">Gọi</span>
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="relative bg-gradient-to-br from-amber-50 to-orange-50 py-12 sm:py-20">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
          style={{
            backgroundImage:
              'url(https://public.readdy.ai/ai/img_res/c5bbfd4857762ac3e3ccd747c6edc1cf.jpg)',
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="text-center lg:text-left">
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
                Văn Phòng Trọn Gói
                <span className="text-amber-600 block">Lotus Office</span>
              </h1>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="#contact"
                  className="bg-amber-600 text-white px-6 sm:px-8 py-3 rounded-lg hover:bg-amber-700 transition-colors text-center cursor-pointer whitespace-nowrap text-sm sm:text-base"
                >
                  Đặt lịch xem văn phòng
                </a>
                <a
                  href="tel:0936685115"
                  className="border-2 border-amber-600 text-amber-600 px-6 sm:px-8 py-3 rounded-lg hover:bg-amber-600 hover:text-white transition-colors text-center cursor-pointer whitespace-nowrap text-sm sm:text-base"
                >
                  Gọi ngay: 093 668 5115
                </a>
              </div>
            </div>
            <div className="relative order-first lg:order-last">
              {/* Image Slideshow */}
              <div className="relative rounded-2xl shadow-2xl overflow-hidden h-64 sm:h-80 lg:h-96">
                {heroImages.map((image, index) => (
                  <div
                    key={index}
                    className={`w-full h-full transition-opacity duration-1000 ${
                      index === currentImageIndex ? 'opacity-100' : 'opacity-0 absolute inset-0'
                    }`}
                    style={{
                      filter: 'brightness(1.1) contrast(1.05) saturate(1.1)',
                    }}
                  >
                    <img
                      src={image}
                      alt={`Lotus Office Interior ${index + 1}`}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                ))}
                
                {/* Slideshow indicators */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                  {heroImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${
                        index === currentImageIndex ? 'bg-white' : 'bg-white/50'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-amber-600 mb-4">Dịch Vụ Trọn Gói</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Lotus Office cung cấp đầy đủ các dịch vụ và tiện ích cần thiết cho hoạt động kinh doanh của bạn
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-2xl hover:shadow-xl transition-shadow border border-gray-100"
              >
                <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-amber-600 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section id="locations" className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-amber-600 mb-4">Cơ Sở Của Chúng Tôi</h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
              Hai địa điểm chiến lược tại Long Biên và Gia Lâm với vị trí đắc địa, giao thông thuận lợi
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
            {locations.map((location, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <img 
                  src={location.image} 
                  alt={location.name} 
                  className="w-full h-48 sm:h-64 object-cover"
                  loading="lazy"
                />
                <div className="p-6 sm:p-8">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">{location.name}</h3>
                  <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">{location.address}</p>
                  <ul className="space-y-2 sm:space-y-3 mb-4 sm:mb-6">
                    {location.features.map((feature, fIdx) => (
                      <li key={fIdx} className="flex items-start space-x-3">
                        <i className="ri-leaf-line text-amber-600 text-lg mt-0.5 flex-shrink-0"></i>
                        <span className="text-gray-700 text-sm sm:text-base">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Google Maps */}
                  <div className="mb-4 sm:mb-6">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center text-sm sm:text-base">
                      <i className="ri-map-pin-line text-amber-600 mr-2"></i>
                      Xem bản đồ và chỉ đường
                    </h4>
                    <div className="relative rounded-lg overflow-hidden shadow-md">
                      <iframe
                        src={
                          index === 0
                            ? 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3723.4737434524!2d105.8918!3d21.0583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135a9f6b9d4c5d7%3A0x8b9c5d4e3f2a1b0c!2sTSG%20Lotus%2C%20190%20S%C3%A0i%20%C4%90%C3%B4ng%2C%20Long%20Bi%C3%AAn%2C%20H%C3%A0%20N%E1%BB%99i!5e0!3m2!1svi!2s!4v1234567890123!5m2!1svi!2s'
                            : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3722.8!2d105.9234!3d21.0789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ab5c8d9e7f1a%3A0x1a2b3c4d5e6f7890!2sVinhomes%20Ocean%20Park%22Gia%20L%C3%A2m%2C%20H%C3%A0%20N%E1%BB%99i!5e0!3m2!1svi!2s!4v1234567890123!5m2!1svi!2s'
                        }
                        width="100%"
                        height="200"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title={`Bản đồ ${location.name}`}
                      ></iframe>
                    </div>
                  </div>

                  {/* Direction Button */}
                  <a
                    href={
                      index === 0
                        ? 'https://maps.app.goo.gl/fSGxWVfS1x2XoRR16'
                        : 'https://maps.app.goo.gl/P6z46ZwecHWHTLrcA'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-amber-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg hover:bg-amber-700 transition-colors whitespace-nowrap text-sm sm:text-base"
                  >
                    <i className="ri-navigation-line mr-2"></i>
                    Chỉ đường đến {location.name}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-amber-600 mb-4">Bảng Giá Dịch Vụ</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Lựa chọn gói dịch vụ phù hợp với nhu cầu và ngân sách của doanh nghiệp bạn
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`relative bg-white rounded-2xl shadow-lg p-8 ${
                  plan.popular ? 'ring-2 ring-amber-600 scale-105' : 'border border-gray-200'
                }`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap">
                      Phổ biến nhất
                    </span>
                  </div>
                )}
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <p className="text-sm text-gray-500 italic mb-4">{plan.subtitle}</p>
                  <div className="mb-2">
                    {plan.name === 'Gói Cao Cấp' && <span className="text-lg text-gray-600">từ </span>}
                    <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                    <span className="text-gray-600 ml-2">{plan.period}</span>
                  </div>
                </div>

                {/* Features list */}
                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, fIdx) => (
                    <li key={fIdx} className="flex items-start space-x-3">
                      <i className="ri-check-line text-amber-600 text-lg mt-0.5"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* Call to action button */}
                <a
                  href="https://zalo.me/0936685115"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-full py-3 px-6 rounded-lg font-medium transition-colors whitespace-nowrap text-center block ${
                    plan.popular
                      ? 'bg-amber-600 text-white hover:bg-amber-7'
                      : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                  }`}
                >
                  Chọn gói này
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-amber-600 mb-4">Khám Phá Lotus Office</h2>
            <p className="text-lg sm:text-xl text-gray-600">Xem video giới thiệu không gian làm việc chuyên nghiệp của chúng tôi</p>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                src="https://www.youtube.com/embed/GYIVrrVvnmY"
                title="Lotus Office Video"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-amber-600 mb-4">Hình Ảnh Thực Tế</h2>
            <p className="text-lg sm:text-xl text-gray-600">Không gian làm việc hiện đại và chuyên nghiệp tại Lotus Office</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            <div className="relative group overflow-hidden rounded-2xl">
              <div
                className="w-full h-48 sm:h-64 group-hover:scale-110 transition-transform duration-300"
                style={{
                  filter: 'brightness(1.1) contrast(1.05) saturate(1.1)',
                }}
              >
                <img
                  src="https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/7d5a4698d1abc4876590ff6223eeea8e.jfif"
                  alt="Office Space 1"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl">
              <div
                className="w-full h-48 sm:h-64 group-hover:scale-110 transition-transform duration-300"
                style={{
                  filter: 'brightness(1.1) contrast(1.05) saturate(1.1)',
                }}
              >
                <img
                  src="https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/59dc4c86e68caa2bed784c5dd7f74d20.jfif"
                  alt="Office Space 2"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl">
              <div
                className="w-full h-48 sm:h-64 group-hover:scale-110 transition-transform duration-300"
                style={{
                  filter: 'brightness(1.1) contrast(1.05) saturate(1.1)',
                }}
              >
                <img
                  src="https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/3c8f98c6f7a417181ca6bce62d8434c3.jfif"
                  alt="Meeting Room"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl">
              <div
                className="w-full h-48 sm:h-64 group-hover:scale-110 transition-transform duration-300"
                style={{
                  filter: 'brightness(1.1) contrast(1.05) saturate(1.1)',
                }}
              >
                <img
                  src="https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/73e6f6ce573420aea7545b63dc8e9a2f.jfif"
                  alt="Reception Area"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl">
              <div
                className="w-full h-48 sm:h-64 group-hover:scale-110 transition-transform duration-300"
                style={{
                  filter: 'brightness(1.1) contrast(1.05) saturate(1.1)',
                }}
              >
                <img
                  src="https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/3c1dd89951fc1303df8a9f26d1aa75ac.jfif"
                  alt="Workspace"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
            </div>
            <div className="relative group overflow-hidden rounded-2xl">
              <div
                className="w-full h-48 sm:h-64 group-hover:scale-110 transition-transform duration-300"
                style={{
                  filter: 'brightness(1.1) contrast(1.05) saturate(1.1)',
                }}
              >
                <img
                  src="https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/155387155cf6bf3f9d444bcc7f21e9a2.jfif"
                  alt="Building Exterior"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-amber-600 mb-4">Liên Hệ Với Chúng Tôi</h2>
            <p className="text-lg sm:text-xl text-gray-600">
              Đặt lịch xem văn phòng hoặc nhận tư vấn miễn phí từ chuyên gia của chúng tôi
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
            {/* Contact Info */}
            <div>
              <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-bold mb-4 flex items-center">
                  <img
                    src="https://static.readdy.ai/image/523a7289a350830dec4e11697fd077ce/2269d27feb85b3888c2fd412aad4574d.jfif"
                    alt="Lotus Office Logo"
                    className="h-6 sm:h-8 w-auto mr-2 sm:mr-3"
                  />
                  <span
                    className="text-xl sm:text-2xl"
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: '700',
                      letterSpacing: '0.05em',
                    }}
                  >
                    LOTUS OFFICE
                  </span>
                </h3>
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                      <i className="ri-phone-line text-amber-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Hotline</h4>
                      <p className="text-gray-600">093 668 5115</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                      <i className="ri-mail-line text-amber-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Email</h4>
                      <p className="text-gray-600">  lotusoffice190@gmail.com</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                      <i className="ri-map-pin-line text-amber-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Địa chỉ</h4>
                      <p className="text-gray-600">TT02-05 TSG Lotus, 190 Sài Đồng, Long Biên</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                      <i className="ri-time-line text-amber-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Giờ làm việc</h4>
                      <p className="text-gray-600">Thứ 2 - Thứ 7: 8:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                {/* Con số ấn tượng */}
                <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-gray-200">
                  <h4 className="font-semibold text-gray-900 mb-4 sm:mb-6 text-base sm:text-lg">Con số ấn tượng</h4>
                  <div className="grid grid-cols-2 gap-3 sm:gap-4">
                    <div className="text-center p-3 sm:p-4 bg-amber-50 rounded-lg">
                      <div className="text-xl sm:text-2xl font-bold text-amber-600">40+</div>
                      <div className="text-xs sm:text-sm text-gray-600">Văn phòng</div>
                    </div>
                    <div className="text-center p-3 sm:p-4 bg-amber-50 rounded-lg">
                      <div className="text-xl sm:text-2xl font-bold text-amber-600">70+</div>
                      <div className="text-xs sm:text-sm text-gray-600">Khách hàng đã trải nghiệm</div>
                    </div>
                    <div className="text-center p-3 sm:p-4 bg-amber-50 rounded-lg">
                      <div className="text-xl sm:text-2xl font-bold text-amber-600">2</div>
                      <div className="text-xs sm:text-sm text-gray-600">Cơ sở</div>
                    </div>
                    <div className="text-center p-3 sm:p-4 bg-amber-50 rounded-lg">
                      <div className="text-xl sm:text-2xl font-bold text-amber-600">5★</div>
                      <div className="text-xs sm:text-sm text-gray-600">Đánh giá</div>
                    </div>
                  </div>
                </div>

                {/* Kết nối với chúng tôi */}
                <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-gray-200">
                  <h4 className="font-semibold text-gray-900 mb-4 sm:mb-6 text-base sm:text-lg">Kết nối với chúng tôi</h4>
                  <div className="flex flex-wrap gap-2 sm:gap-3">
                    <a
                      href="https://www.facebook.com/lotusoffice190sd"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:bg-amber-7..."
                    >
                      <i className="ri-facebook-fill text-base sm:text-lg"></i>
                    </a>
                    <a
                      href="https://youtu.be/GYIVrrVvnmY?si=-G8PwwdRv9MA6m7A"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:bg-amber-7..."
                    >
                      <i className="ri-youtube-fill text-base sm:text-lg"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@lotusoffice190saidong"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:amber-7..."
                    >
                      <i className="ri-tiktok-fill text-base sm:text-lg"></i>
                    </a>
                    <a
                      href="https://zalo.me/0936685115"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:bg-amber-7..."
                    >
                      <i className="ri-chat-3-fill text-base sm:lg"></i>
                    </a>
                    <a
                      href="mailto:lotusoffice190@gmail.com"
                      className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:bg-amber-7..."
                    >
                      <i className="ri-mail-fill text-base sm:text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
              <h3
                className="text-xl sm:text-2xl font-bold mb-4"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '700',
                  letterSpacing: '0.05em',
                }}
              >
                LOTUS OFFICE
              </h3>
              <form className="space-y-4 sm:space-y-6" data-readdy-form id="contact-form" onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Họ và tên *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm sm:text-base"
                    placeholder="Nhập họ và tên của bạn"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Số điện thoại *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm sm:text-base"
                    placeholder="Nhập số điện thoại"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm sm:text-base"
                    placeholder="Nhập địa chỉ email"
                  />
                </div>

                <div>
                  <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-2">
                    Cơ sở quan tâm
                  </label>
                  <select
                    id="location"
                    name="location"
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-600 focus:border-transparent pr-8 text-sm sm:text-base"
                  >
                    <option value="">Chọn cơ sở</option>
                    <option value="lotus1">Lotus Office 1 - Long Biên</option>
                    <option value="lotus2">Lotus Office 2 - Gia Lâm</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Tin nhắn
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    maxLength={500}
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:amber-600 focus:border-transparent text-sm sm:text-base"
                    placeholder="Nhập yêu cầu hoặc câu hỏi của bạn (tối đa 500 ký tự)"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-amber-600 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:bg-amber-700 transition-colors font-medium whitespace-nowrap text-sm sm:text-base"
                >
                  Gửi yêu cầu
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3
                className="text-2xl font-bold mb-4"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '700',
                  letterSpacing: '0.05em',
                }}
              >
                Lotus Office
              </h3>
              <p className="text-gray-400 mb-4">
                Văn phòng dịch vụ trọn gói chuyên nghiệp tại Hà Nội với không gian hiện đại và vị trí đắc địa.
              </p>
              <div className="flex space-x-3">
                <a
                  href="https://www.facebook.com/lotusoffice190sd"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:bg-amber-700 hover:text-white transition-all duration-300 hover:scale-110"
                >
                  <i className="ri-facebook-fill text-sm"></i>
                </a>
                <a
                  href="https://youtu.be/GYIVrrVvnmY?si=-G8PwwdRv9MA6m7A"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:bg-amber-7..."
                >
                  <i className="ri-youtube-fill text-sm"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@lotusoffice190saidong"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:amber-7..."
                >
                  <i className="ri-tiktok-fill text-sm"></i>
                </a>
                <a
                  href="https://zalo.me/0936685115"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:bg-amber-7..."
                >
                  <i className="ri-chat-3-fill text-sm"></i>
                </a>
                <a
                  href="mailto:lotusoffice190@gmail.com"
                  className="w-8 h-8 bg-amber-600 text-white rounded-lg flex items-center justify-center hover:bg-amber-7..."
                >
                  <i className="ri-mail-fill text-sm"></i>
                </a>
              </div>
            </div>

            {/* Services Column */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Dịch vụ</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="#services" className="hover:text-white transition-colors">
                    Văn phòng khép kín
                  </a>
                </li>
                <li>
                  <a href="#services" className="hover:text-white transition-colors">
                    Phòng họp
                  </a>
                </li>
                <li>
                  <a href="#services" className="hover:text-white transition-colors">
                    Dịch vụ lễ tân
                  </a>
                </li>
                <li>
                  <a href="#services" className="hover:text-white transition-colors">
                    Sảnh tiếp khách
                  </a>
                </li>
              </ul>
            </div>

            {/* Locations */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Cơ Sở</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <p className="font-medium text-white">Lotus Office 1</p>
                  <p className="text-sm">TT02-05 TSG Lotus, 190 Sài Đồng, Long Biên</p>
                </li>
                <li>
                  <p className="font-medium text-white">Lotus Office 2</p>
                  <p className="text-sm">SB23-147 &amp; SB23-367, Vinhomes Ocean Park</p>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Liên hệ</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center space-x-2">
                  <i className="ri-phone-line"></i>
                  <span>093 668 5115</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-mail-line"></i>
                  <span>  lotusoffice190@gmail.com</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-time-line"></i>
                  <span>8:00 - 22:0 (Hàng ngày)</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
            <p>&copy; 2023 Lotus Office. Tất cả các quyền được bảo lưu.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
